import { useCallback, useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "../lib/api";
import { FileText } from "lucide-react";
import { toast } from "sonner";
import { DocTable } from "../components/documents/DocTable";
import { DocPreviewModal } from "../components/documents/DocPreview";
import { RejectModal } from "../components/documents/RejectModal";

const FILTERS = ["pending", "verified", "rejected", "all"];

export default function Documents() {
  const [docs, setDocs] = useState([]);
  const [filter, setFilter] = useState("pending");
  const [previewing, setPreviewing] = useState(null);
  const [rejectId, setRejectId] = useState(null);

  const load = useCallback(async () => {
    const q = filter === "all" ? "" : `?status=${filter}`;
    const r = await api.get(`/documents${q}`);
    setDocs(r.data);
  }, [filter]);
  useEffect(() => { load(); }, [load]);

  const approve = async (id) => {
    try {
      await api.patch(`/documents/${id}`, { status: "verified" });
      toast.success("Approved"); load();
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
  };

  return (
    <div className="space-y-6" data-testid="documents-page">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-slate-500 font-semibold">Verification</div>
          <h1 className="font-display text-2xl sm:text-3xl md:text-4xl font-black tracking-tighter">Documents</h1>
        </div>
        <div className="flex gap-2">
          {FILTERS.map((f) => (
            <button key={f} onClick={() => setFilter(f)} data-testid={`filter-${f}`}
                    className={`px-4 py-2 text-sm uppercase tracking-wider border ${
                      filter === f ? "bg-slate-900 text-white border-slate-900" : "bg-white text-slate-700 border-slate-200 hover:bg-slate-50"
                    }`}>{f}</button>
          ))}
        </div>
      </div>

      <div className="bg-white border border-slate-200 overflow-x-auto">
        {docs.length === 0 ? (
          <div className="p-12 text-center text-slate-500 flex flex-col items-center gap-2" data-testid="documents-empty">
            <FileText className="h-8 w-8 text-slate-300" /> No {filter === "all" ? "" : filter} documents.
          </div>
        ) : (
          <DocTable docs={docs} onView={setPreviewing} onApprove={approve} onReject={setRejectId} />
        )}
      </div>

      {rejectId && <RejectModal docId={rejectId} onDone={() => { setRejectId(null); load(); }} onCancel={() => setRejectId(null)} />}
      {previewing && <DocPreviewModal doc={previewing} onClose={() => setPreviewing(null)} />}
    </div>
  );
}
